(function () {
  'use strict';
  if (window.__smCloudflareMap) return;
  var history = window.__smShopifyHistory || {};
  function key(r) { return [r.country || '', r.region || '', r.city || ''].join('|'); }
  function point(r) { return r.lat != null && r.lng != null && r.lat !== '' && r.lng !== '' && Number.isFinite(Number(r.lat)) && Number.isFinite(Number(r.lng)) && Math.abs(Number(r.lat)) <= 90 && Math.abs(Number(r.lng)) <= 180; }
  function merge(live) {
    var rows = new Map(), countries = new Map();
    function add(r, count) {
      var k = key(r), x = rows.get(k);
      if (!x) { x = {country:r.country || '', region:r.region || '', city:r.city || '', lat:null, lng:null, lifetime:0, visits_24h:0, visits_7d:0, active_count:0}; rows.set(k, x); }
      x.lifetime += Number(count) || 0;
      if (point(r)) { x.lat = Number(r.lat); x.lng = Number(r.lng); }
      return x;
    }
    (history.hierarchical || []).forEach(function(c) { (c.regions || []).forEach(function(r) { (r.cities || []).forEach(function(v) { add({country:c.country,region:r.region,city:v.city},v.lifetime_count); }); }); });
    (history.routes || []).forEach(function(r) { var x=rows.get(key(r)); if(!x) x=add(r,r.lifetime); else if(point(r)){x.lat=Number(r.lat);x.lng=Number(r.lng);} });
    (live.routes || []).forEach(function(r) { var x=add(r,r.lifetime); x.visits_24h += Number(r.visits_24h)||0; x.visits_7d += Number(r.visits_7d)||0; });
    (live.active || []).forEach(function(v) { var x=rows.get(key(v.location || {})); if(x)x.active_count++; });
    var routes=Array.from(rows.values());
    routes.forEach(function(r) {
      var c=countries.get(r.country);if(!c){c={country:r.country,regions:[],lifetime_count:0,active_count:0,visits_24h:0,visits_7d:0};countries.set(r.country,c);}
      var region=c.regions.find(function(x){return x.region===r.region;});if(!region){region={region:r.region,cities:[],lifetime_count:0,active_count:0,visits_24h:0,visits_7d:0};c.regions.push(region);}
      region.cities.push({city:r.city,lifetime_count:r.lifetime,active_count:r.active_count,visits_24h:r.visits_24h,visits_7d:r.visits_7d});
      ['lifetime_count','active_count','visits_24h','visits_7d'].forEach(function(k){var n=k==='lifetime_count'?r.lifetime:r[k];region[k]+=n;c[k]+=n;});
    });
    return Object.assign({},live,{routes:routes,heat:routes.filter(point),hierarchical:Array.from(countries.values()),history_timestamp:history.timestamp});
  }
  window.__smCloudflareMap={merge:merge};
})();
